import { BACKEND_API_URL } from "../Config";
import { handleApiResponse } from "../Utils";


export const requestPhoneVerifyCode = async ({ phoneNumber, onSuccess, onError }) => {
    try {                
        console.log("requestVerifyCode:", phoneNumber)
        const response = await fetch(
            `${BACKEND_API_URL}/sms-verification/send-verify-code`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ phoneNumber }),
            }            
        );

        const data = await handleApiResponse(response, "requestPhoneVerifyCode");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};